export const GET_ENUMS = {
  popup: {
    confirmPhone: 'confirm-phone',
    confirmEmail: 'confirm-email',
  },
};
